import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Upload } from "lucide-react";

const seedFallback = [
  "https://images.unsplash.com/photo-1764605206511-7a649d9df63b?w=1200",
  "https://images.pexels.com/photos/18251570/pexels-photo-18251570.jpeg?w=1200",
  "https://images.pexels.com/photos/14463716/pexels-photo-14463716.jpeg?w=1200",
  "https://images.unsplash.com/photo-1628901341130-4f2255b326f2?w=1200",
  "https://images.pexels.com/photos/11877375/pexels-photo-11877375.jpeg?w=1200",
  "https://images.pexels.com/photos/16180485/pexels-photo-16180485.jpeg?w=1200",
];

const backendOrigin = API.replace(/\/api$/, "");
const resolveUrl = (u) => (u?.startsWith("http") ? u : `${backendOrigin}${u}`);

export default function Gallery() {
  const { user } = useAuth() || {};
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery")
      .then(({ data }) => setItems(data))
      .finally(() => setLoading(false));
  }, []);

  const uploaded = items.map((i) => ({ src: resolveUrl(i.url), caption: i.caption, id: i.id }));
  const fallback = seedFallback.map((src, i) => ({ src, caption: "", id: `seed-${i}` }));
  const all = [...uploaded, ...fallback];

  return (
    <div className="bg-[#040B16] text-white">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <div className="eyebrow mb-3">Gallery</div>
            <h1 className="font-display font-extrabold text-5xl sm:text-6xl tracking-tighter">Moments from the road.</h1>
          </div>
          {user?.role === "admin" && (
            <Link to="/admin?tab=gallery" className="btn-gold !py-2 !px-5 !text-sm" data-testid="gallery-manage-btn">
              <Upload className="w-4 h-4" /> Manage photos
            </Link>
          )}
        </div>

        {loading ? (
          <div className="text-white/50">Loading gallery…</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {all.map((img) => (
              <figure key={img.id} className="overflow-hidden rounded-2xl border border-white/10 group relative" data-testid={`gallery-item-${img.id}`}>
                <img src={img.src} alt={img.caption || ""} loading="lazy"
                  className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-700" />
                {img.caption && (
                  <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-sm">
                    {img.caption}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
